var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLivejournalWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.048 2.115a9.9 9.9 0 0 0-3.951.816L5.91.75h-.005A9.98 9.98 0 0 0 .75 5.93l2.19 2.185-.002.002a9.8 9.8 0 0 0-.843 3.94 9.93 9.93 0 0 0 2.914 7.03A9.95 9.95 0 0 0 12.047 22C17.543 22 22 17.549 22 12.057c0-5.489-4.457-9.94-9.952-9.94",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#15374C",
  fillRule: "evenodd",
  d: "M11.034 16.186a9.99 9.99 0 0 1 5.155-5.18h.002L8.098 2.935l-.003-.001a9.98 9.98 0 0 0-5.157 5.18zm5.735-2.423a5.8 5.8 0 0 0-2.994 3.009l3.779.78-.784-3.79",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m16.768 13.766-.578-2.758h-.003a10 10 0 0 0-5.155 5.18l2.742.585a5.83 5.83 0 0 1 2.994-3.008",
  clipRule: "evenodd"
})));
export default SvgLivejournalWhite;